import { apiConf, sendRequest, ppAxios } from '../config'

/**
 * 个人认证
 */
export const uploadFile = param => {
	return sendRequest(apiConf.certificationApi.uploadFile, param)
}

export const downloadFile = (param, option) => {
	return ppAxios(apiConf.certificationApi.downloadFile, param, option)
}

export const personal = param => {
	return sendRequest(apiConf.certificationApi.personal, param)
}

export const company = param => {
	return sendRequest(apiConf.certificationApi.company, param)
}

export const kycSubmit = () => {
	return sendRequest(apiConf.certificationApi.kycSubmit)
}

export const query = param => {
	return sendRequest(apiConf.certificationApi.query, param)
}

export const getWriter = param => {
	return sendRequest(apiConf.certificationApi.getWriter, param)
}

export const deleteFile = param => {
	return sendRequest(apiConf.certificationApi.deleteFile, param)
}

// 获取证件到期弹框信息
export const getExpireCertification = params => {
	return sendRequest(apiConf.certificationApi.getExpireCertification, params)
}

// 证件到期 - 获取详情数据
export const getExpireCertificationDetail = params => {
	return sendRequest(apiConf.certificationApi.getExpireCertificationDetail, params)
}

// 证件到期 - 提交修改 法人股东受益人
export const submitCertificationDetail = params => {
	return sendRequest(apiConf.certificationApi.submitCertificationDetail, params)
}

// 证件到期 - 提交修改 公司
export const submitCertifiCompanyDetail = params => {
	return sendRequest(apiConf.certificationApi.submitCertifiCompanyDetail, params)
}

// 证件变更记录
export const updateHistory = params => {
	return sendRequest(apiConf.certificationApi.updateHistory, params)
}

// 证件到期提醒列表
export const updateRequired = params => {
	return sendRequest(apiConf.certificationApi.updateRequired, params)
}

// 法人股东受益人变更
export const customerCreateOrDelete = params => {
	return sendRequest(apiConf.certificationApi.customerCreateOrDelete, params)
}

/**
 * 获取审核通过的网站列表
 */
// export const getStoreList = param => {
//   return sendRequest(apiConf.certificationApi.storeList, param);
// };
/**
 * 导出excel表格
 */
// export const exportExcel = (param, options) => {
//   return ppAxios(apiConf.certificationApi.exportExcel, param, options);
// };
